import { render, staticRenderFns } from "./InputIdentification.vue?vue&type=template&id=d6d5b3aa&scoped=true&"
import script from "./InputIdentification.vue?vue&type=script&lang=js&"
export * from "./InputIdentification.vue?vue&type=script&lang=js&"
import style0 from "./InputIdentification.vue?vue&type=style&index=0&id=d6d5b3aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d5b3aa",
  null
  
)

export default component.exports